import { composeWithDevTools } from "redux-devtools-extension";
import { createBrowserHistory as createHistory } from "history";
import { createEpicMiddleware } from "redux-observable";
import { createLogger } from "redux-logger";
import { createReduxHistoryContext } from "redux-first-history";
import { createStore, applyMiddleware, combineReducers } from "redux";
import { persistStore } from "redux-persist";
import { reducer as formReducer } from "redux-form";
import thunk from "redux-thunk";

import reducers from "./rootReducer";
import rootEpic from "./rootEpic";

const epicMiddleware = createEpicMiddleware();

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({
    history: createHistory(),
    //others options if needed
  });

const getMiddleware = () => {
  if (process.env.NODE_ENV === "production") {
    return applyMiddleware(epicMiddleware, routerMiddleware, thunk);
  } else {
    // Enable additional logging in non-production environments.
    return applyMiddleware(
      epicMiddleware,
      routerMiddleware,
      thunk,
      createLogger()
    );
  }
};

const rootReducer = combineReducers({
  router: routerReducer,
  form: formReducer,
  ...reducers,
});

const store = createStore(rootReducer, composeWithDevTools(getMiddleware()));

//- MUST run to subscribe
epicMiddleware.run(rootEpic);

export const persistor = persistStore(store);

export const history = createReduxHistory(store);

export default store;
